/**
 * Public barrel export for the CountBadge molecule (SE-6589).
 * @module components/molecules/CountBadge
 */
export { default } from "./CountBadgeView";
export type { CountBadgeProps } from "./CountBadgeView";
